import { render } from "./chipsButton.vue?vue&type=template&id=daebce74"
import script from "./chipsButton.vue?vue&type=script&lang=js"
export * from "./chipsButton.vue?vue&type=script&lang=js"

import "./chipsButton.vue?vue&type=style&index=0&id=daebce74&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__